// extracted by mini-css-extract-plugin
export default {"ExtensionContentHeader":"_ExtensionContentHeader--E1QJL","ExtensionContentBody":"_ExtensionContentBody--uYtd3"};